import { ReactElement } from "react";

import SecondaryButton, { SecondaryButtonProps } from "components/core/SecondaryButton";

import classes from "./IconSecondary.module.scss";

type IconSecondaryButtonProps = {
  icon?: ReactElement;
} & SecondaryButtonProps

export const IconSecondaryButton = (props: IconSecondaryButtonProps) => {
  const { icon, ...secondaryButtonProps } = props;

  secondaryButtonProps.className = classes.iconButton;

  return (
    <SecondaryButton {...secondaryButtonProps}>
      { icon }
    </SecondaryButton>
  );
};
